// File: src/components/overlays/BottomSheetModal.tsx

import React from "react";
import styled, { keyframes } from "styled-components";

interface BottomSheetModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const slideUp = keyframes`
  from { transform: translateY(100%) }
  to { transform: translateY(0%) }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
  animation: ${fadeIn} 0.2s ease-out;
`;

const Sheet = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.surface};
  border-top-left-radius: ${({ theme }) => theme.radii.lg};
  border-top-right-radius: ${({ theme }) => theme.radii.lg};
  padding: ${({ theme }) => theme.spacing.md};
  z-index: 1001;
  animation: ${slideUp} 0.25s ease-out;
`;

export const BottomSheetModal: React.FC<BottomSheetModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <Overlay onClick={onClose} />
      <Sheet>{children}</Sheet>
    </>
  );
};